import { createApp } from 'vue';
import App from './App.vue';
import router from './routes';
import { store } from './store';

import Vue3Shortkey from 'vue3-shortkey';
import Notifications from '@kyvg/vue3-notification';
import { vMaska } from 'maska';
import { Money3Directive } from 'v-money3';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import vClickOutside from 'v-click-outside';
import 'leaflet/dist/leaflet.css';
import TagsInput from 'vue3-tags-input';
import VueDraggable from 'vuedraggable';
import VToggle from '@vueform/toggle';
import { VueDatePicker } from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

import { configure, defineRule } from 'vee-validate';
import { localize, setLocale } from '@vee-validate/i18n';
import { required, min, email } from '@vee-validate/rules';
import ptBR from '@vee-validate/i18n/dist/locale/pt_BR.json';

defineRule('required', required);
defineRule('min', min);
defineRule('email', email);

configure({
  generateMessage: localize({ pt_BR: ptBR }),
});
setLocale('pt_BR');

const app = createApp(App);

app.use(router);
app.use(store);

app.use(Notifications);

app.use(Toast, {
  position: 'bottom-right',
  timeout: 5000,
});

app.directive('money', Money3Directive);

app.use(vClickOutside);
app.use(Vue3Shortkey);

app.directive('maska', vMaska);

app.component('tags-input', TagsInput);
app.component('VueDraggable', VueDraggable);
app.component('VToggle', VToggle);
app.component('VueDatePicker', VueDatePicker);

app.mount('#app');
